import React, { useEffect, useState } from "react";
import styles from "./CareerDetailContainer.module.css";
import RichText from "../RichText/RichText";
import SchoolFaq from "../SchoolFaq/SchoolFaq";
import SimilarRoles from "../SimilarRoles/SimilarRoles";

interface Banner {
  id: number;
  title: string;
  description: string;
  desktop_img: {
    url: string;
  };
  mobile_img: {
    url: string;
  };
}

interface CareerData {
  id: number;
  category: string;
  banner: Banner;
  slug: string;
}

interface CareerPageData {
  job_summary: any;
  frequently_asked_questions?: any;
  category: string;
}

interface CareerDetailContainerProps {
  careerPageData: CareerPageData;
  carrerDetailAllPageData: CareerData[];
  slug: any;
}

const CareerDetailContainer: React.FC<CareerDetailContainerProps> = ({
  careerPageData,
  carrerDetailAllPageData,
  slug,
}) => {
  const [filteredData, setFilteredData] = useState<CareerData[]>([]);

  useEffect(() => {
    const filtered = carrerDetailAllPageData.filter(
      (item) => item.category === careerPageData.category && item.slug !== slug
    );
    setFilteredData(filtered);
  }, [carrerDetailAllPageData, careerPageData.category, slug]);

  return (
    <div className="container">
      <div className={styles.careerDetailContainer}>
        <div
          className={
            filteredData?.length === 0
              ? `${styles.careerLeft} ${styles.careerLeftFullWidth}`
              : styles.careerLeft
          }
        >
          {careerPageData?.job_summary && (
            <div className={styles.careerJobSummary}>
              <RichText data={careerPageData?.job_summary} />
            </div>
          )}
          <div className={styles.careerFaq}>
            {careerPageData?.frequently_asked_questions && (
              <SchoolFaq
                data={careerPageData?.frequently_asked_questions}
                grayDesign
              />
            )}
          </div>
        </div>
        {/* Only show careerRight if there is at least one similar role */}
        {filteredData.length > 0 && (
          <div className={styles.careerRight}>
            <div className={styles.careerCard}>
              <SimilarRoles data={filteredData} />
            </div>
          </div>
        )}
      </div>
      <div className={styles.careerFaqMobile}>
        {careerPageData.frequently_asked_questions && (
          <SchoolFaq
            data={careerPageData.frequently_asked_questions}
            grayDesign
          />
        )}
      </div>
    </div>
  );
};

export default CareerDetailContainer;
